// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { BillingProvider } from "./context/BillingContext"; // ✅ ADD THIS

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <AuthProvider>
      <BillingProvider> {/* ✅ ADD THIS */}
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </BillingProvider>
    </AuthProvider>
  </React.StrictMode>
);